import { useRequest } from 'ahooks';
import { useNavigate } from 'react-router-dom';

import { implog } from '@/api/implog';
import { getPayType } from '@/api/recharge';
import showNiceModal from '@/components/nice-modal';
import { ACCESS_USERID_KEY } from '@/constant/config';
import RechargeModal from '@/modules/modal/recharge-modal';
import { gameStore } from '@/stores/game';
import { modalStore } from '@/stores/modal';
import globalStore from '@/stores/store';
import { isInApk, openInBrowser } from '@/utils/apk';
import Storage from '@/utils/Storage';
import { getDevice } from '@/utils/utils';

import useParam from './useParam';

type rechargeParams = {
  onSuccess?: () => void;
  onCallback?: (data: any) => void;
  selectType?: boolean;
};

const useRecharge = (params: rechargeParams = {}) => {
  const { onSuccess, onCallback, selectType = true } = params;
  const navigate = useNavigate();
  const { type } = useParam<{ type?: number }>();

  const isGameing = !!(type && +type === 1);

  const { runAsync: runRecharge, loading } = useRequest(
    async (data: API.RechargeRequest) => {
      let payProduct = '';
      let { from } = data;
      if (globalStore.isNeedBindPhone && !globalStore?.initialState?.is_bind_mobile) {
        modalStore.openBindPhone();
        return;
      }
      if (from === undefined) {
        from = isGameing ? 1 : 0;
      }
      if (selectType) {
        const paytype = await getPayType({
          p_userid: Storage.getAccess(ACCESS_USERID_KEY)
        });
        if (paytype?.record?.length === 1 && paytype?.record[0]?.payproduct) {
          payProduct = paytype.record[0].payproduct;
        } else {
          const args = btoa(
            `amount=${data.amount}&from=${from}&cztype=${data?.cztype || ''}&serverid=${data?.serverid || ''}`
          );
          navigate(`/recharge/choose/${args}`);
          return;
        }
      }
      return showNiceModal(
        {
          maskClosable: false,
          closable: {
            hideClose: true
          },
          top: '50%',
          chaining: true,
          backdrop: {
            backgroundColor: 'rgba(0, 0, 0, 0)'
          },
          contentStyle: {
            background: 'transparent',
            transform: 'translateY(-100%)'
          },
          innerProps: { data: { payProduct, ...data, from }, isGameing },
          render: RechargeModal
        },
        'recharge-loading-modal'
      );
    },
    {
      manual: true,
      debounceLeading: true,
      debounceTrailing: false,
      debounceWait: 800,
      onSuccess: (res: any, [data]) => {
        if (res?.ret === 0) {
          onSuccess?.();
          onCallback?.(res);
          console.log('res.payment_data', res.payment_data, data);
          implog('payment_data', res.payment_data);
          const payment_data = res.payment_data;
          res?.onClose?.();
          if (payment_data?.payurl) {
            const url = decodeURIComponent(payment_data.payurl);
            if (isInApk()) {
              openInBrowser(url);
              gameStore.hideLoading();
              return;
            } else {
              const device = getDevice();
              const isIos = device === 'ios';
              if (isIos) {
                const newWindow = window.open('', '_blank');
                (newWindow as Window).location.href = url;
              } else {
                window.open(url);
              }
              gameStore.hideLoading();
              return;
            }
          }
          // let str = '';

          // // 15 是 SPEI 渠道
          // const args = {
          //   url: payment_data?.payurl
          // };
          // str = window.btoa(JSON.stringify(args));

          // navigate(`/pay/${str}`, {
          //   // replace: isGameing
          // });
        } else {
          gameStore.hideLoading();
        }
      },
      onError: () => {
        gameStore.hideLoading();
      }
    }
  );

  return {
    runRecharge,
    isGameing,
    loading
  };
};

export default useRecharge;
